import React from 'react';

const AuditIcon = ({ isActive }) => {
  return (
    <svg
      width='30'
      height='30'
      viewBox='0 0 512 512'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g
        id='SVGRepo_bgCarrier'
        strokeWidth='0'
      ></g>
      <g
        id='SVGRepo_tracerCarrier'
        strokeLinecap='round'
        strokeLinejoin='round'
        stroke={isActive ? '#ffffffa3' :'#525876'}
        strokeWidth='6.144'
      ></g>
      <g id='SVGRepo_iconCarrier'>
        {' '}
        <title>audit-report</title>{' '}
        <g
          id='Page-1'
          strokeWidth='0.00512'
          fill={isActive ? '#ffffffa3' :'#525876'}
          fillRule='evenodd'
        >
          {' '}
          <g
            id='icon'
            fill={isActive ? '#ffffffa3' :'#525876'}
            transform='translate(42.665250, 42.666667)'
          >
            {' '}
            <path
              d='M341.33475,42.6666667 L426.668083,128 L426.668083,384 L0.00141677613,384 L1.36004076e-14,151.329691 C10.0983011,166.682012 24.2153849,184.436546 42.6673443,199.495392 L42.6680834,341.333333 L384.001417,341.333333 L384.001417,138.666667 L330.668083,85.3333333 L290.932237,85.3351205 C285.492739,74.6817682 276.348053,58.8452682 263.198008,42.6667242 L341.33475,42.6666667 Z M341.33475,277.333333 L341.33475,298.666667 L85.3347501,298.666667 L85.3347501,277.333333 L341.33475,277.333333 Z M341.33475,213.333333 L341.33475,234.666667 L213.33475,234.666667 L213.334687,214.29601 C213.875883,213.977904 214.414374,213.65703 214.950164,213.333459 L341.33475,213.333333 Z M138.668083,7.10542736e-15 C235.73475,7.10542736e-15 277.33475,106.666667 277.33475,106.666667 C277.33475,106.666667 235.73475,213.333333 138.668083,213.333333 C41.6014168,213.333333 0.00141677613,106.666667 0.00141677613,106.666667 C0.00141677613,106.666667 41.6014168,7.10542736e-15 138.668083,7.10542736e-15 Z M138.668083,26.6666667 C77.3774168,26.6666667 41.6014168,83.7333333 30.3694168,106.666667 C41.6014168,129.6 77.3774168,186.666667 138.668083,186.666667 C199.95875,186.666667 235.73475,129.6 246.96675,106.666667 C235.73475,83.7333333 199.95875,26.6666667 138.668083,26.6666667 Z M138.668083,60 C165.472303,60 187.201417,80.8933783 187.201417,106.666667 C187.201417,132.439955 165.472303,153.333333 138.668083,153.333333 C111.863864,153.333333 90.1347501,132.439955 90.1347501,106.666667 C90.1347501,80.8933783 111.863864,60 138.668083,60 Z M138.668083,86.6666667 C127.180561,86.6666667 117.868083,95.6209717 117.868083,106.666667 C117.868083,117.712362 127.180561,126.666667 138.668083,126.666667 C150.155606,126.666667 159.468083,117.712362 159.468083,106.666667 C159.468083,95.6209717 150.155606,86.6666667 138.668083,86.6666667 Z'
              id='Combined-Shape'
            >
              {' '}
            </path>{' '}
          </g>{' '}
        </g>{' '}
      </g>
    </svg>
  );
};

export default AuditIcon;
